import { Container, DropdownMenu, Text } from "../../shared";
import { hooks, mainSelectors, mainOperations, dataTrackingOperations, authSelectors } from "../../../state";
import { useNavigate } from "react-router-dom"
import { useState } from "react"
import { getUserFromSubcookies } from "../../../utils";
import { allowedRoles, appNames } from "../../../utils/constants";
import SidebarStyled from "./sidebar-styled";

const Sidebar = () => {
  const { selectHeaderTabs, selectmain, selectWorkbookTabs } = mainSelectors;
  const { selectWorkbookGroup, setSidebarOpen, setModalOpen, setSelectedModalContent } = mainOperations;
  const { useAppSelector, useAppDispatch } = hooks
  const { selectedWorkbookGroup, appType} = useAppSelector(selectmain)
  const [pendingPOSInvite, setPendingPOSInvite] = useState(false)
  
  const userCookie = getUserFromSubcookies()
  const roles = userCookie?.profile.role || []
  let showSwitch = false
  let switchTo = ''
  if(Array.isArray(roles)){
    showSwitch = roles.includes(allowedRoles.legacy_insights) && roles.includes(allowedRoles.insights)
    if(appType === appNames.insights){
      switchTo = appNames.legacy
    }else{
      switchTo = appNames.insights
    }
  }

  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const { trackEvent } = dataTrackingOperations
  const handleOnClickPOSInvite = () => {
    setPendingPOSInvite(true)
    dispatch(setSidebarOpen(false))
    dispatch(setModalOpen(true))
    dispatch(setSelectedModalContent('posInvite'))
    dispatch(trackEvent({ 
      eventCategory: 'navigate', 
      values: 'pos_invite_opened', 
      event: 'options_menu' 
    }))
  }

  const handleOnClickSwitch = async (destinationApp:string) => {
    await dispatch(trackEvent({ eventCategory: 'switch', values: JSON.stringify({ targetApp: destinationApp}), event: 'switch_from_menu' }))
    window.location.assign(`${process.env.REACT_APP_LANDING_URL}/${destinationApp}?originApp=${appType}`)
  }

  const signOut = async () => {
    await dispatch(trackEvent({eventCategory: 'switch', values: JSON.stringify({ targetApp: 'PAM' }), event: 'switch_on_logout'}))
    window.location.assign(`${process.env.REACT_APP_LANDING_URL}/logout?originApp=${appType}`)
  }

  const headerTabs = useAppSelector(selectHeaderTabs)
  const workbookTabs = useAppSelector(selectWorkbookTabs)

  const workbookList = workbookTabs?.map((workbook: any) => ({ label: workbook.tabLabel, key: workbook.workbookGuid }))
  const selectNewWorkbook = (({ label: tabLabel, key }: any) => {
    dispatch(setSidebarOpen(false))
    navigate(`/${tabLabel.replaceAll(' ', '_').toLowerCase()}/${key}`)
  })

  const renderHeaderLink = (label: string) => {
    const isActive = label === selectedWorkbookGroup
    return (
      <Container key={label} className={`${isActive ? 'selected ' : ''}header-link`} onClick={() => dispatch(selectWorkbookGroup(label))}>
        <DropdownMenu
          onHover={() => dispatch(selectWorkbookGroup(label))}
          label={label}
          options={workbookList || []}
          onChange={(value: any) => { return value && selectNewWorkbook(value) }}
          arrowDirection="left-right"
        />
      </Container>
    )
  }
  return (
    <SidebarStyled>
      <Text textStyle="h4" color={'brandDark'}>Workbooks</Text>
      <Container className={'sidebar-workbooks-links'}>
        {headerTabs.map((link: any) => renderHeaderLink(link.groupString))}
      </Container>
      <div
        className="sidebar-external-links"
      >
        <div className="divider"></div>
        <Container className={'navigation-link'} onClick={handleOnClickPOSInvite}>
          <Text textStyle="h4" color="brandDark">Invite POS Retailer</Text>
        </Container>
        <div className="divider"></div>
        <Container className={'navigation-link'} onClick={() => handleOnClickSwitch(appNames.pistilnext)}>
          <Text textStyle="h4" color="brandDark">Go to Pistil Next</Text>
        </Container>
        {showSwitch && (
          <>
            <div className="divider"></div>
            <Container className={'navigation-link'} onClick={() => handleOnClickSwitch(switchTo)}>
              <Text textStyle="h4" color="brandDark">{appType === 'insights'?'Switch to v.1':'Switch to v.2'}</Text>
            </Container>
          </>
        )}
        <div className="divider"></div>
        <Container className={'navigation-link'} onClick={() => {
          dispatch(trackEvent({ eventCategory: 'navigate', values: '', event: 'contact_us' }))
          // TODO: Move support@pistildata.com email to an env variable
          window.open('mailto:support@pistildata.com?subject=Subject&body=Body%20goes%20here')
        }}>
          <Text textStyle="h4" color="brandDark">Contact Us</Text>
        </Container>
        <div className="divider"></div>
        <Container className={'navigation-link'}
        onClick={() => signOut()}>
          <Text textStyle="h4" color="brandDark">Sign Out</Text>
        </Container>
      </div>
    </SidebarStyled>
  );
}

export default Sidebar